export function leadDisplayName(lead) {
  if (!lead) return "Unknown";
  const name = [lead.firstName, lead.lastName].filter(Boolean).join(" ").trim();
  return name || lead.name || "Unknown";
}

export function leadInitials(lead) {
  const name = leadDisplayName(lead);
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return (parts[0]?.[0] || "?").toUpperCase();
}

export function formatRelativeTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const diffMs = Date.now() - date.getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "now";
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function formatMessageTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function formatDateDivider(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function groupMessagesByDate(messages) {
  const groups = [];
  let currentKey = null;
  let current = null;
  for (const message of messages || []) {
    const stamp = message.sentAt || message.deliveredAt || message.createdAt;
    const key = stamp ? new Date(stamp).toDateString() : "unknown";
    if (key !== currentKey) {
      currentKey = key;
      current = { key, label: formatDateDivider(stamp), messages: [] };
      groups.push(current);
    }
    current.messages.push(message);
  }
  return groups;
}

export function snippetPreview(message) {
  if (!message) return "";
  const prefix = message.direction === "OUTBOUND" ? "You: " : "";
  const body = (message.content || message.subject || "").replace(/\s+/g, " ").trim();
  if (!body) return `${prefix}—`;
  return `${prefix}${body.length > 80 ? `${body.slice(0, 80)}…` : body}`;
}
